import React from 'react';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import Money from '@components/Gui/Money';
import TransactionTitle from '@components/Transactions/TransactionTitle';

import { getCommissionLabel, isMainStatementLine } from '../helpers';

const getBillingSearchModelName = (transaction) => {
    if (!transaction?.ModelID) {
        return null;
    }

    const fullName = [transaction.ModelName, transaction.ModelSurname].filter(Boolean).join(' ').trim();

    return fullName || getContactName(transaction.ModelID);
};

const getUsageLabel = (project, usageID) => {
    const usage = project?.Usages?.find((item) => item.ID === usageID);

    if (!usage || !usage.Areas?.length) {
        return null;
    }

    return `${usage.Areas[0]} - ${usage.Duration}`.toLocaleLowerCase();
};

const renderExternalFee = (transaction) => {
    if (!(transaction?.ExternalFee > 0)) {
        return null;
    }

    return (
        <small>
            MODEL FEE: <Money amount={transaction.ExternalFee} currency={transaction.Currency} />
        </small>
    );
};

const StatementTitleCell = ({
    row,
    statementType,
    variant = 'billing-search',
    project,
    isExpanded = false,
    hideModelName = false,
}) => {
    const shouldShowModelName = !hideModelName && statementType !== 'Model' && row.Transaction?.ModelID;

    if (variant === 'billing-search' || variant === 'commissions-search') {
        if (row.Transaction?.Family === 'JobFee' && isMainStatementLine(row)) {
            return (
                <div className="transaction-left">
                    {shouldShowModelName && (
                        <small className="transaction-model">{getBillingSearchModelName(row.Transaction)}</small>
                    )}
                    <small>Job Fee</small>
                </div>
            );
        }

        return (
            <div className="transaction-left">
                {shouldShowModelName && (
                    <small className="transaction-model">{getBillingSearchModelName(row.Transaction)}</small>
                )}
                {row.isCommission && variant !== 'commissions-search' && (
                    <small className="transaction-commission">
                        {getCommissionLabel({ statementType, variant: 'long' })}
                    </small>
                )}
                {row.isClientAdvance && <small className="transaction-advance">Client Advance</small>}
                <TransactionTitle transaction={row.Transaction} />
                {renderExternalFee(row.Transaction)}
            </div>
        );
    }

    if (row.isCommission) {
        return (
            <div className="transaction-left">
                <small>{getCommissionLabel({ statementType, variant: 'long' })}</small>
            </div>
        );
    }

    if (row.isClientAdvance) {
        return (
            <div className="transaction-left">
                <small>Client Advance / Payroll</small>
            </div>
        );
    }

    const usageLabel = getUsageLabel(project, row.Transaction?.UsageID);

    return (
        <div className="transaction-left">
            {shouldShowModelName && (
                <small className="transaction-model">{getContactName(row.Transaction.ModelID)}</small>
            )}
            <TransactionTitle transaction={row.Transaction} />

            {/* {isExpanded && (
                <>
                    <div>{row.Description || <em className="super-muted">no description</em>}</div>
                    <TransactionEvent transaction={row.Transaction} project={project} />
                    {usageLabel && <div>{usageLabel}</div>}
                </>
            )} */}
            {renderExternalFee(row.Transaction)}
        </div>
    );
};

export default StatementTitleCell;
